import { render } from "./GroupsCreate.vue?vue&type=template&id=714a8d6a&scoped=true"
import script from "./GroupsCreate.vue?vue&type=script&lang=js"
export * from "./GroupsCreate.vue?vue&type=script&lang=js"

import "./GroupsCreate.vue?vue&type=style&index=0&id=714a8d6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714a8d6a"]])

export default __exports__